const ErrorCodes = {
  accountAlreadyExists: 'account_already_exists',
  challengeRequired: 'challenge_required',
  duplicatePromotions: 'duplicate_promotions',
  invalidCredentials: 'invalid_credentials',
  phoneRequired: 'phone_required',
  twoFactorRequired: 'two_factor_required',
  unknownError: 'unknown_error',
  userNotFound: 'user_not_found',
  verificationCodeRequired: 'verification_code_required'
};

export default ErrorCodes;
